export default {
  label: {
    tooltip: 'This survey belongs to the staging environment.',
    environment: 'Staging',
  },
};
